"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import s from "underscore.string";
import React from "react";
import _ from "underscore";
import Account from "../../api/account";
import Auth from "../../util/auth";
import CarrierName from "../carrier_name";
import "../../services/carrier_service";
import classNames from "classnames";
import HoverableValueTable from "../hoverable_value_table";
import moment from "moment";
import { allReferences } from "../../helpers/references";
import { externalLinkIcon } from "../ui/icons";
class LoadTable extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "rowChanged", (item) => {
      if (item.selected) {
        this.props.onSelectionChange(void 0);
      } else {
        this.props.onSelectionChange(item.loadState);
      }
    });
    this.state = {
      cssClass: "import-detail__load-table",
      config: {
        columns: {
          load_id: { name: "Load ID" },
          status: { name: "Status" },
          carrier_name: { name: Account.carrierTerm() },
          shipped: { name: "Shipped" },
          carrier_charge: { name: "Amount" },
          origin: { name: "Origin" },
          destination: { name: "Destination" }
        }
      }
    };
  }
  currency(string) {
    if (string && !s.isBlank(string)) {
      return "$" + s.numberFormat(parseFloat(string), 2);
    }
  }
  address(item, prefix) {
    if (item[prefix + "_city"] && item[prefix + "_state"]) {
      return item[prefix + "_city"] + ", " + item[prefix + "_state"];
    } else if (item[prefix + "_name"]) {
      return item[prefix + "_name"];
    }
  }
  date(item) {
    if (item) {
      return moment(item).format("L");
    }
  }
  isHighlighted(load) {
    return this.props.highlightedLoads.indexOf(load.id) >= 0;
  }
  cssClasses(load) {
    return classNames({
      "import-detail__load-table__matched": this.isHighlighted(load)
    });
  }
  references(item) {
    return allReferences(item);
  }
  loadIdFormat(item) {
    if (item.source_system === "hubtran" && item.load_id.includes("dummy")) {
      return "DRAFT LOAD";
    } else {
      return item.load_id;
    }
  }
  format(loadStates) {
    return _.map(loadStates, (loadState) => {
      var item = loadState.load;
      return {
        load_id: this.loadIdFormat(item),
        status: item.status,
        pickup_reference: item.pickup_reference,
        carrier_name: item.carrier_id ? /* @__PURE__ */ React.createElement(CarrierName, { carrierID: item.carrier_id }) : null,
        shipped: this.date(item.actual_shipped_at),
        carrier_charge: this.currency(item.carrier_charge),
        carrier_id: item.carrier_id,
        origin: this.address(item, "origin"),
        destination: this.address(item, "destination"),
        css_class: this.cssClasses(loadState),
        selected: this.props.selectedLoadStateId === loadState.id,
        references: this.references(item),
        loadState,
        id: loadState.id
      };
    });
  }
  tdClassName(itemAttribute, item) {
    if (itemAttribute == "carrier_name" && this.props.loadsNotFromEmailCarrier && this.props.loadsNotFromEmailCarrier(item.loadState)) {
      return "load-list__nonmatching-carrier";
    }
  }
  table(items) {
    var rows = [];
    if (!_.isEmpty(items)) {
      var summaryCells = (x) => {
        return this.columnNames().map((c) => {
          return /* @__PURE__ */ React.createElement("td", { key: c, className: this.tdClassName(c, x) }, x[c]);
        });
      };
      items.forEach((item) => {
        var _a;
        var clicker = () => {
          this.rowChanged(item);
        };
        var cells = summaryCells(item);
        rows.push(
          /* @__PURE__ */ React.createElement("tr", { key: item.id, className: item.css_class }, /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
            "input",
            {
              onChange: clicker,
              checked: item.selected,
              type: "checkbox",
              className: "mousetrap"
            }
          )), cells)
        );
        if (item.selected || items.length === 1) {
          rows.push(
            /* @__PURE__ */ React.createElement("tr", { key: item.id + "_detail", className: item.css_class }, /* @__PURE__ */ React.createElement("td", { className: "show_for_non_reskin" }, "\xA0"), /* @__PURE__ */ React.createElement(
              "td",
              {
                className: "import-detail__reference-td",
                colSpan: cells.length + 1
              },
              /* @__PURE__ */ React.createElement("div", { className: "import-detail__reference-header" }, "References", !((_a = Auth.getCurrentUser()) == null ? void 0 : _a.managed_indexer) && /* @__PURE__ */ React.createElement(
                "a",
                {
                  className: "import-detail__reference-header__load-link",
                  href: `/app/loads/${item.loadState.id}`,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  title: "Go to load",
                  "aria-label": "Go to load"
                },
                externalLinkIcon()
              )),
              /* @__PURE__ */ React.createElement(
                HoverableValueTable,
                {
                  items: this.referencesFor(item),
                  onValueHighlighted: this.props.highlightChanged
                }
              )
            ))
          );
        }
      });
    } else {
      rows.push(
        /* @__PURE__ */ React.createElement("tr", { key: "no_items" }, /* @__PURE__ */ React.createElement("td", { colSpan: 8 }, /* @__PURE__ */ React.createElement("div", { className: "alert-box--caution" }, /* @__PURE__ */ React.createElement("em", null, "No matching loads found in TMS data received by TriumphPay Audit."))))
      );
    }
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("table", { cellSpacing: "0", className: this.state.cssClass }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", { className: "header" }, /* @__PURE__ */ React.createElement("th", null), this.header())), /* @__PURE__ */ React.createElement("tbody", null, rows)));
  }
  columnNames() {
    return Object.keys(this.state.config.columns);
  }
  allowedReferenceFields() {
    const settings = Account.currentSettings() || {};
    return settings.tms_reference_fields || [];
  }
  referencesFor(item) {
    var _a;
    const allowedReferenceFields = this.allowedReferenceFields();
    var selectedReferences;
    if ((_a = Auth.getCurrentUser()) == null ? void 0 : _a.managed_indexer) {
      selectedReferences = [];
      const rawReferences = item.loadState.load.references;
      _.each(rawReferences, (v, k) => {
        selectedReferences.push({ name: k, value: v, hoverable: true });
      });
    } else if (_.isEmpty(allowedReferenceFields)) {
      selectedReferences = item.references;
    } else {
      selectedReferences = _.chain(allowedReferenceFields).map((field) => item.references.filter((ref) => ref.name === field)).flatten().value();
    }
    if (item.origin) {
      selectedReferences.push({
        name: "Origin",
        value: item.origin,
        hoverable: true
      });
    }
    if (item.destination) {
      selectedReferences.push({
        name: "Destination",
        value: item.destination,
        hoverable: true
      });
    }
    return selectedReferences;
  }
  header() {
    return this.columnNames().map((c) => {
      return /* @__PURE__ */ React.createElement("th", { key: c, className: "header " }, this.state.config.columns[c].name);
    });
  }
  render() {
    var items = this.format(this.props.items);
    return /* @__PURE__ */ React.createElement("div", { className: "load-table__items-container" }, this.table(items));
  }
}
export default LoadTable;
